import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://www.turevisionsegura.com';
const SUPABASE_URL = import.meta.env.VITE_PUBLIC_SUPABASE_URL;

const vehicleTypes = [
  {
    id: 'pasajeros', emoji: '🚌', label: 'Público Pasajeros',
    tag: 'Servicio Público',
    rewards: ['KIT VELKO VEHICULO', 'TARJETA DE ASISTENCIA PARA TODOS', 'PREVENTIVAS GRATUITAS PARA SERVIO PUBLICO DE PASAJEROS'],
  },
  {
    id: 'carga', emoji: '🚛', label: 'Público y Particular de Cargas',
    tag: 'Servicio Público / Particular',
    rewards: ['KIT VELKO VEHICULO', 'TARJETA DE ASISTENCIA PARA TODOS'],
  },
  {
    id: 'particular', emoji: '🚗', label: 'Particular',
    tag: 'Servicio Particular',
    rewards: ['KIT VELKO VEHICULO', 'TARJETA DE ASISTENCIA PARA TODOS'],
  },
  {
    id: 'moto', emoji: '🏍️', label: 'Motos',
    tag: 'Servicio Particular / Público',
    rewards: ['TARJETA DE ASISTENCIA CARD PLUS', 'LIMPIADOR DE CADENA PARA MOTO'],
  },
];

const assistances = [
  { icon: 'ri-flight-takeoff-line', title: 'Traslado al Aeropuerto', desc: 'Tú y 3 acompañantes desde tu casa hasta el aeropuerto.', uses: '2 usos/año', img: 'https://public.readdy.ai/ai/img_res/136fcc84527188666e3885d0e47e2a1e.jpg' },
  { icon: 'ri-video-chat-line', title: 'Mecánico por Video-Llamada', desc: 'Orientación técnica de expertos en mecánica automotriz en caso de varada.', uses: '2 usos/año', img: 'https://readdy.ai/api/search-image?query=professional%20automotive%20mechanic%20working%20on%20car%20engine%20in%20dark%20garage%20with%20dramatic%20lighting%2C%20tools%20and%20equipment%20visible%2C%20orange%20and%20dark%20blue%20color%20palette%2C%20cinematic%20industrial%20photography%2C%20close%20up%20engine%20detail&width=400&height=300&seq=assist-mechanic-01&orientation=landscape' },
  { icon: 'ri-battery-charge-line', title: 'Reinicio de Batería', desc: 'Servicio de reinicio del sistema eléctrico en caso de varada por batería.', uses: '1 uso/año', img: 'https://readdy.ai/api/search-image?query=car%20battery%20with%20jumper%20cables%20glowing%20electric%20sparks%20on%20dark%20background%2C%20dramatic%20electric%20blue%20and%20orange%20light%2C%20automotive%20emergency%20service%2C%20close%20up%20macro%20photography%2C%20dark%20moody%20atmosphere&width=400&height=300&seq=assist-battery-01&orientation=landscape' },
  { icon: 'ri-e-bike-line', title: 'Te lo Llevamos', desc: 'Mensajería para recoger paquetes o pagar cuentas. Máx. 1 kg, trayecto hasta 20 km.', uses: '1 uso/año', img: 'https://readdy.ai/api/search-image?query=delivery%20courier%20on%20motorcycle%20riding%20through%20city%20streets%20at%20night%20with%20motion%20blur%20lights%2C%20urban%20Colombia%20street%20scene%2C%20warm%20orange%20street%20lights%2C%20dark%20background%20with%20bokeh%20effect%2C%20professional%20photography&width=400&height=300&seq=assist-delivery-01&orientation=landscape' },
  { icon: 'ri-stethoscope-line', title: 'Orientación Veterinaria', desc: 'Video-llamada para urgencias de tu mascota que no requieran atención presencial.', uses: '2 usos/año', img: 'https://readdy.ai/api/search-image?query=veterinarian%20examining%20a%20dog%20with%20stethoscope%20in%20modern%20clinic%2C%20warm%20soft%20lighting%2C%20professional%20medical%20setting%2C%20dark%20background%20with%20amber%20tones%2C%20caring%20and%20professional%20atmosphere%2C%20close%20up%20portrait&width=400&height=300&seq=assist-vet-01&orientation=landscape' },
  { icon: 'ri-home-heart-line', title: 'Guardería para Mascotas', desc: 'Cobertura de guardería para tu mascota si sales de viaje. Solo perros y gatos.', uses: '1 uso/año', img: 'https://readdy.ai/api/search-image?query=happy%20dog%20and%20cat%20together%20in%20cozy%20pet%20daycare%20facility%20with%20warm%20lighting%2C%20comfortable%20beds%20and%20toys%2C%20soft%20amber%20and%20warm%20tones%2C%20professional%20pet%20care%20photography%2C%20dark%20moody%20background&width=400&height=300&seq=assist-petcare-01&orientation=landscape' },
  { icon: 'ri-file-shield-2-line', title: 'Documentos Protegidos', desc: 'Cubrimos el costo de reposición si pierdes o te roban tus documentos.', uses: '1 uso/año', img: 'https://readdy.ai/api/search-image?query=official%20documents%20passport%20and%20ID%20cards%20with%20security%20shield%20protection%20concept%2C%20dark%20background%20with%20golden%20light%20rays%2C%20legal%20protection%20theme%2C%20professional%20studio%20photography%2C%20Colombia%20identity%20documents&width=400&height=300&seq=assist-docs-01&orientation=landscape' },
  { icon: 'ri-heart-pulse-line', title: 'Orientación Médica', desc: 'Orientación médica por video-llamada en caso de enfermedad o accidente. 24/7.', uses: '2 usos/año', img: 'https://readdy.ai/api/search-image?query=doctor%20in%20white%20coat%20on%20video%20call%20consultation%20with%20patient%2C%20modern%20telemedicine%20concept%2C%20dark%20background%20with%20soft%20blue%20and%20amber%20lighting%2C%20professional%20medical%20photography%2C%20digital%20health%20technology&width=400&height=300&seq=assist-medical-01&orientation=landscape' },
];

const kitProducts = [
  { icon: 'ri-drop-line', title: 'Refrigerante Anticorrosivo', subtitle: 'INCLUIDO PARA TODOS LOS VEHÍCULOS' },
  { icon: 'ri-settings-3-line', title: 'Líquido de Frenos', subtitle: 'INCLUIDO PARA TODOS LOS VEHÍCULOS' },
  { icon: 'ri-bubble-chart-line', title: 'Spray Multipropósito', subtitle: 'INCLUIDO PARA TODOS LOS VEHÍCULOS' },
];



export default function Servicios() {
  const [activeVehicle, setActiveVehicle] = useState('particular');
  const [activeTab, setActiveTab] = useState<'asistencias' | 'kit'>('asistencias');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [hoveredAssistance, setHoveredAssistance] = useState<number | null>(null);

  useEffect(() => {
    document.title = 'Recompensas REVISION SEGURA | Kit VELKO + 8 Asistencias Card Plus · Alianza Técnica Colombia';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Descubre los beneficios exclusivos de la Plataforma de Gestión de Beneficios de la Alianza Técnica: Kit VELKO premium y 8 asistencias Card Plus. Valores agregados otorgados por la alianza, con la RTM al costo legal vigente.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${SITE_URL}/servicios`);
    return () => {};
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openDoc = (docName: string) => {
    window.open(`${SUPABASE_URL}/storage/v1/object/public/DOCUMENTS/${docName}`, '_blank');
  };

  const openAgent = () => {
    const btn = document.querySelector('#vapi-widget-floating-button') as HTMLElement | null;
    if (btn) btn.click();
  };

;

  return (
    <div className="min-h-screen font-sans overflow-x-hidden"
      style={{ background: 'radial-gradient(ellipse at 50% 30%, #1a3a6e 0%, #152d55 55%, #0f2040 100%)' }}>

      {/* ── NAV ── */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'backdrop-blur-xl shadow-2xl' : 'bg-transparent'}`}
        style={scrolled ? { background: 'rgba(13,27,42,0.92)', borderBottom: '1px solid rgba(200,121,65,0.18)' } : {}}>
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/257ded5cf4b1165b373a01f4236f0b3a/e052755f997086e5f1ed7f5d0f41046d.png"
              alt="REVISION SEGURA Logo"
              className="h-10 w-auto object-contain"
              style={{ filter: 'drop-shadow(0 4px 16px rgba(0,0,0,0.9)) drop-shadow(0 0 8px rgba(200,121,65,0.3))' }}
            />
          </Link>
          <div className="hidden md:flex items-center gap-8">
            {([['/', 'Inicio'], ['/servicios', 'Recompensas'], ['/contacto', 'Contacto']] as [string, string][]).map(([to, label]) => (
              <Link key={to} to={to}
                className="text-xs font-semibold tracking-wider transition-colors whitespace-nowrap"
                style={{ color: to === '/servicios' ? '#C87941' : 'rgba(255,255,255,0.5)' }}>
                {label}
              </Link>
            ))}
          </div>
          <button className="md:hidden text-white/70 w-8 h-8 flex items-center justify-center cursor-pointer" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-white/5 px-6 py-4 flex flex-col gap-3"
            style={{ background: 'rgba(0,0,0,0.95)' }}>
            {([['/', 'Inicio'], ['/servicios', 'Recompensas'], ['/contacto', 'Contacto']] as [string, string][]).map(([to, label]) => (
              <Link key={to} to={to} className="text-sm text-white/70 hover:text-white font-medium" onClick={() => setIsMobileMenuOpen(false)}>{label}</Link>
            ))}
          </div>
        )}
      </nav>

      {/* ── HERO ── */}
      <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden pt-16">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=cinematic%20aerial%20view%20of%20modern%20highway%20at%20night%20with%20light%20trails%20from%20cars%2C%20long%20exposure%20photography%2C%20dark%20moody%20atmosphere%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20ultra%20wide%20angle%2C%20dramatic%20depth%20of%20field%2C%20professional%20automotive%20photography%2C%20Colombia%20urban%20landscape&width=1920&height=1080&seq=hero-servicios-v2&orientation=landscape"
            alt="hero"
            className="w-full h-full object-cover object-center"
            style={{ filter: 'brightness(0.75) saturate(1.0)' }}
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(15,32,64,0.55) 0%, rgba(21,45,85,0.35) 50%, #0f2040 100%)' }}></div>
        </div>

        <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full blur-3xl animate-pulse"
          style={{ background: 'rgba(200,121,65,0.1)' }}></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full blur-3xl animate-pulse"
          style={{ background: 'rgba(32,192,208,0.09)', animationDelay: '1s' }}></div>

        <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-8 backdrop-blur-sm">
            <span className="w-2 h-2 rounded-full animate-pulse" style={{ background: '#C87941' }}></span>
            <span className="text-xs text-white/90 font-semibold tracking-widest uppercase">Alianza Técnica · REVISION SEGURA</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-black text-white leading-none mb-6 tracking-tight">
            TUS{' '}
            <span style={{
              color: '#FF6B1A',
              textShadow: '0 0 20px rgba(255,107,26,0.9), 0 0 60px rgba(255,107,26,0.4)',
            }}>
              RECOMPENSAS
            </span>
          </h1>

          <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            Paga tu tarifa legal de <strong className="text-white">$370.000</strong> y activa de inmediato un paquete de beneficios valorado en más de <strong style={{ color: '#E8A020' }}>$300.000</strong>. Al registrarte con el código de tu taller aliado, activas tu participación por un <strong className="text-white">Reconocimiento Especial basado en los resultados de la Lotería de Bogotá</strong>. Al realizar tu RTM con el Taller Aliado, recibes tu <strong className="text-white">Kit Profesional VELKO</strong> y tu <strong className="text-white">Tarjeta Card Plus</strong> con 8 asistencias nacionales. Si adquieres llantas con la alianza, también generas un <strong style={{ color: '#E8A020' }}>Bono de Reembolso por Fidelidad de hasta $100.000</strong> — cuyo monto depende del rin, diseño y valor de las llantas.
          </p>

          {/* Selector de tipo de vehículo */}
          <div className="flex flex-wrap justify-center gap-3 mb-10">
            {vehicleTypes.map(v => (
              <button
                key={v.id}
                onClick={() => setActiveVehicle(v.id)}
                className="flex items-center gap-2 px-5 py-2.5 text-sm font-bold transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{
                  borderRadius: '4px',
                  border: activeVehicle === v.id ? '1px solid rgba(200,121,65,0.7)' : '1px solid rgba(255,255,255,0.25)',
                  background: activeVehicle === v.id
                    ? 'linear-gradient(135deg, #C87941, #E8A020)'
                    : 'rgba(255,255,255,0.1)',
                  color: activeVehicle === v.id ? '#fff' : 'rgba(255,255,255,0.80)',
                  boxShadow: activeVehicle === v.id ? '0 0 20px rgba(200,121,65,0.4)' : 'none',
                  transform: activeVehicle === v.id ? 'scale(1.05)' : 'scale(1)',
                }}
              >
                <span>{v.emoji}</span>
                <span>{v.label}</span>
              </button>
            ))}
          </div>


        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <i className="ri-arrow-down-s-line text-white/50 text-2xl"></i>
        </div>
      </section>

      {/* ── CÓMO FUNCIONA ── */}
      <section className="py-20 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #0f2040 0%, #152d55 100%)' }}>
        {/* Líneas decorativas */}
        <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(200,121,65,0.4), transparent)' }}></div>
        <div className="absolute bottom-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(200,121,65,0.2), transparent)' }}></div>

        <div className="relative z-10 max-w-5xl mx-auto px-6">
          {/* Encabezado */}
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 mb-5 px-5 py-2 rounded-full"
              style={{ background: 'rgba(200,121,65,0.1)', border: '1px solid rgba(200,121,65,0.3)' }}>
              <span className="w-2 h-2 rounded-full animate-pulse" style={{ background: '#C87941' }}></span>
              <span className="text-xs text-white/60 font-bold tracking-widest uppercase">Proceso Simple · 3 Pasos</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-none mb-4 tracking-tight">
              ¿CÓMO{' '}
              <span style={{ color: '#FF6B1A', textShadow: '0 0 30px rgba(255,107,26,0.7)' }}>FUNCIONA?</span>
            </h2>
            <p className="text-white/50 text-base max-w-lg mx-auto">
              Registro en QR → Realización de RTM ($370.000) → Entrega de Beneficios (Kit VELKO, Card Plus y Bono Llantas si aplica).
            </p>
          </div>

          {/* Pasos */}
          <div className="grid md:grid-cols-3 gap-6 relative">
            {/* Línea conectora desktop */}
            <div className="hidden md:block absolute top-16 left-[calc(16.66%+24px)] right-[calc(16.66%+24px)] h-px"
              style={{ background: 'linear-gradient(90deg, rgba(200,121,65,0.6), rgba(232,160,32,0.8), rgba(200,121,65,0.6))' }}></div>

            {[
              {
                num: '01',
                icon: 'ri-qr-code-line',
                color: '#C87941',
                glow: 'rgba(200,121,65,0.35)',
                title: 'Registro en QR',
                subtitle: 'Activa tu participación',
                desc: 'Escanea el QR del taller aliado y registra tus datos con el código del Programa Empresarial Privado. Al registrarte, activas tu participación por un Reconocimiento Especial basado en los resultados de la Lotería de Bogotá de cada jueves.',
                tag: 'PASO 1 — REGISTRO',
                badge: null,
              },
              {
                num: '02',
                icon: 'ri-car-line',
                color: '#FF6B1A',
                glow: 'rgba(255,107,26,0.35)',
                title: 'Realización de RTM',
                subtitle: 'Kit VELKO + Card Plus activados',
                desc: 'Al completar tu Revisión Tecnomecánica ($370.000) con el Taller Aliado, recibes tu Kit Profesional VELKO y tu Tarjeta Card Plus con 8 asistencias nacionales. Servicio público de pasajeros: también incluye Revisiones Preventivas Gratuitas.',
                tag: 'PASO 2 — RTM $370.000',
                badge: null,
              },
              {
                num: '03',
                icon: 'ri-money-dollar-circle-line',
                color: '#E8A020',
                glow: 'rgba(232,160,32,0.35)',
                title: 'Entrega de Beneficios',
                subtitle: 'Kit, Card Plus y Bono Llantas',
                desc: 'Kit VELKO y Card Plus se entregan ese mismo día. El Bono de Reembolso por Fidelidad para llantas se coordina directamente con el Taller Aliado y el operador. El monto depende del rin, diseño y valor de las llantas.',
                tag: 'PASO 3 — BENEFICIOS',
                badge: 'BONO LLANTAS: SOLO SI APLICA',
              },
            ].map((step, i) => (
              <div key={i} className="relative flex flex-col items-center text-center group">
                {/* Número grande de fondo */}
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 text-[120px] font-black leading-none select-none pointer-events-none"
                  style={{ color: 'rgba(255,255,255,0.02)', zIndex: 0 }}>
                  {step.num}
                </div>

                {/* Ícono */}
                <div className="relative z-10 w-28 h-28 flex items-center justify-center mb-5 transition-transform duration-300 group-hover:scale-105"
                  style={{
                    background: `radial-gradient(circle, ${step.glow} 0%, rgba(15,32,64,0.95) 70%)`,
                    border: `1px solid ${step.color}55`,
                    borderRadius: '4px',
                    boxShadow: `0 0 35px ${step.glow}`,
                  }}>
                  <i className={`${step.icon} text-4xl`} style={{ color: step.color }}></i>
                  {/* Punto numerado */}
                  <div className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center font-black text-[10px] text-white"
                    style={{ background: `linear-gradient(135deg, ${step.color}, #E8A020)`, borderRadius: '50%' }}>
                    {i + 1}
                  </div>
                </div>

                {/* Tag */}
                <span className="inline-flex items-center px-3 py-1 text-[10px] font-black tracking-widest uppercase mb-3"
                  style={{ background: `${step.color}18`, border: `1px solid ${step.color}40`, borderRadius: '3px', color: step.color }}>
                  {step.tag}
                </span>

                {/* Contenido */}
                <div className="relative z-10 p-5 w-full"
                  style={{
                    background: 'rgba(15,32,64,0.85)',
                    border: i === 2 ? '1px solid rgba(232,160,32,0.35)' : '1px solid rgba(200,121,65,0.18)',
                    borderRadius: '4px',
                    backdropFilter: 'blur(10px)',
                  }}>
                  <h3 className="text-white font-black text-base mb-1 leading-tight">{step.title}</h3>
                  <p className="text-[11px] font-bold mb-2 uppercase tracking-widest" style={{ color: step.color }}>{step.subtitle}</p>
                  <p className="text-white/55 text-xs leading-relaxed">{step.desc}</p>
                  {step.badge && (
                    <div className="mt-3 inline-flex items-center gap-1.5 px-2.5 py-1 text-[10px] font-black uppercase tracking-widest"
                      style={{ background: 'rgba(232,160,32,0.12)', border: '1px solid rgba(232,160,32,0.4)', borderRadius: '3px', color: '#E8A020' }}>
                      <i className="ri-information-line"></i>
                      {step.badge}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Mecánica del incentivo */}
          <div className="mt-10 p-5 flex items-start gap-4"
            style={{
              background: 'linear-gradient(135deg, rgba(255,107,26,0.08), rgba(232,160,32,0.05))',
              border: '1px solid rgba(255,107,26,0.35)',
              borderRadius: '4px',
            }}>
            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center"
              style={{ background: 'rgba(255,107,26,0.15)', border: '1px solid rgba(255,107,26,0.4)', borderRadius: '4px' }}>
              <i className="ri-trophy-line text-lg" style={{ color: '#FF6B1A' }}></i>
            </div>
            <div>
              <p className="text-white font-black text-sm mb-1">Mecánica del Reconocimiento Especial — Lotería de Bogotá</p>
              <p className="text-white/60 text-xs leading-relaxed">
                Los <strong className="text-white">3 últimos números de tu placa</strong>, en estricto orden, se comparan con los 3 últimos dígitos del <strong style={{ color: '#E8A020' }}>premio mayor de la Lotería de Bogotá</strong> publicado cada jueves.
                Si coinciden, <strong className="text-white">recuperas hasta el 100% del valor de tu RTM</strong>. Un premio a tu responsabilidad vial — reconocimiento comercial de la Alianza de Beneficios, no un juego de azar. Aplica únicamente para vehículos livianos particulares y públicos.
              </p>
            </div>
          </div>

          {/* CTA final */}
          <div className="mt-10 text-center">
            <Link to="/contacto"
              className="inline-flex items-center gap-3 font-black px-10 py-4 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap text-sm text-white uppercase tracking-widest"
              style={{
                background: 'linear-gradient(135deg, #C87941, #E8A020)',
                borderRadius: '4px',
                boxShadow: '0 4px 20px rgba(200,121,65,0.4)',
              }}
              onMouseEnter={e => (e.currentTarget.style.boxShadow = '0 0 28px 6px rgba(220,100,20,0.55)')}
              onMouseLeave={e => (e.currentTarget.style.boxShadow = '0 4px 20px rgba(200,121,65,0.4)')}>
              <i className="ri-trophy-line text-base"></i>
              ACTIVAR MI PAQUETE DE BENEFICIOS
            </Link>
            <p className="text-white/30 text-xs mt-3 max-w-sm mx-auto leading-relaxed">
              El registro es presencial en el taller aliado. El código del Programa Empresarial Privado es entregado por el canal oficial.
            </p>
          </div>
        </div>
      </section>

      {/* ── BENEFICIOS ── */}
      <section id="beneficios" className="py-20" style={{ background: '#1a3a6e' }}>
        <div className="max-w-6xl mx-auto px-6">
          {/* Tabs */}
          <div className="flex justify-center mb-14">
            <div className="flex gap-1 p-1" style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.18)', borderRadius: '4px' }}>
              <button
                onClick={() => setActiveTab('asistencias')}
                className="px-6 py-2.5 text-sm font-bold transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{
                  borderRadius: '4px',
                  background: activeTab === 'asistencias' ? 'linear-gradient(135deg, #C87941, #E8A020)' : 'transparent',
                  color: activeTab === 'asistencias' ? '#fff' : 'rgba(255,255,255,0.70)',
                  boxShadow: activeTab === 'asistencias' ? '0 0 16px rgba(200,121,65,0.35)' : 'none',
                }}>
                <i className="ri-customer-service-2-line mr-2"></i>
                TARJETA DE ASISTENCIA
              </button>
              <button
                onClick={() => setActiveTab('kit')}
                className="px-6 py-2.5 text-sm font-bold transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{
                  borderRadius: '4px',
                  background: activeTab === 'kit' ? 'linear-gradient(135deg, #C87941, #E8A020)' : 'transparent',
                  color: activeTab === 'kit' ? '#fff' : 'rgba(255,255,255,0.70)',
                  boxShadow: activeTab === 'kit' ? '0 0 16px rgba(200,121,65,0.35)' : 'none',
                }}>
                <i className="ri-box-3-line mr-2"></i>
                KIT VELKO VEHICULO Y/O MOTO
              </button>
            </div>
          </div>

          {/* ── ASISTENCIAS ── */}
          {activeTab === 'asistencias' && (
            <div>
              <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-black text-white mb-3">
                  <span style={{ color: '#C87941' }}>TARJETA DE ASISTENCIA PARA TODOS</span>
                </h2>
                <p className="text-white/70 text-sm max-w-xl mx-auto">
                  Bonificación por Servicio Realizado. Al completar tu RTM con el Taller Aliado y verificar el proceso técnico en el CDA, activas automáticamente tu cobertura de asistencias Card Plus. Este beneficio se entrega al hacer tu RTM — no depende de la compra de llantas. Valor agregado exclusivo otorgado por la Alianza Técnica, impulsado por Card Plus y Gestión Automotriz AW2020.
                </p>
              </div>

              {/* ── NOTA DE ENTREGA CARD PLUS ── */}
              <div className="mb-8 p-5 flex items-start gap-4"
                style={{
                  background: 'linear-gradient(135deg, rgba(200,121,65,0.12), rgba(232,160,32,0.08))',
                  border: '1px solid rgba(200,121,65,0.55)',
                  borderRadius: '4px',
                }}>
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center"
                  style={{ background: 'linear-gradient(135deg, #C87941, #E8A020)', borderRadius: '4px', boxShadow: '0 0 16px rgba(200,121,65,0.4)' }}>
                  <i className="ri-customer-service-2-line text-white text-lg"></i>
                </div>
                <div>
                  <p className="text-white font-black text-sm mb-1 uppercase tracking-widest">
                    ¿Cuándo se activa tu Tarjeta Card Plus?
                  </p>
                  <p className="text-white/75 text-xs leading-relaxed">
                    La Tarjeta de Asistencia Card Plus se activa <strong className="text-white">el mismo día que realizas tu Revisión Tecnomecánica (RTM)</strong> con el Taller Aliado, una vez verificado el proceso técnico en el CDA.{' '}
                    <strong style={{ color: '#E8A020' }}>No requiere compra de llantas ni ningún otro requisito adicional</strong> — es tu beneficio directo por cumplir con tu responsabilidad vial.
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {assistances.map((a, i) => (
                  <div
                    key={i}
                    onMouseEnter={() => setHoveredAssistance(i)}
                    onMouseLeave={() => setHoveredAssistance(null)}
                    className="relative group transition-all duration-500 hover:scale-[1.03] overflow-hidden"
                    style={{
                      border: hoveredAssistance === i ? '1px solid rgba(200,121,65,0.7)' : '1px solid rgba(255,255,255,0.12)',
                      borderRadius: '4px',
                      minHeight: '260px',
                    }}
                  >
                    {/* Imagen de fondo */}
                    <div className="absolute inset-0 w-full h-full">
                      <img
                        src={a.img}
                        alt={a.title}
                        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                      />
                      {/* Overlay degradado fuerte para legibilidad */}
                      <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(10,20,45,0.45) 0%, rgba(10,20,45,0.75) 45%, rgba(5,12,30,0.97) 100%)' }}></div>
                      {/* Overlay de color en hover */}
                      <div className="absolute inset-0 transition-opacity duration-500"
                        style={{ background: 'rgba(200,121,65,0.18)', opacity: hoveredAssistance === i ? 1 : 0 }}></div>
                    </div>

                    {/* Contenido */}
                    <div className="relative z-10 p-5 flex flex-col gap-3 h-full" style={{ minHeight: '260px' }}>
                      {/* Ícono */}
                      <div className="w-12 h-12 flex items-center justify-center flex-shrink-0 transition-all duration-300"
                        style={{
                          background: hoveredAssistance === i ? 'rgba(200,121,65,0.35)' : 'rgba(255,255,255,0.15)',
                          border: hoveredAssistance === i ? '1px solid rgba(200,121,65,0.8)' : '1px solid rgba(255,255,255,0.3)',
                          borderRadius: '4px',
                          backdropFilter: 'blur(8px)',
                        }}>
                        <i className={`${a.icon} text-xl transition-colors duration-300`}
                          style={{ color: hoveredAssistance === i ? '#E8A020' : '#fff' }}></i>
                      </div>

                      {/* Texto */}
                      <div className="mt-auto">
                        <p className="text-white font-black text-sm leading-tight mb-2"
                          style={{ textShadow: '0 1px 6px rgba(0,0,0,0.9)' }}>
                          {a.title}
                        </p>
                        <p className="text-white/80 text-xs leading-relaxed mb-3"
                          style={{ textShadow: '0 1px 4px rgba(0,0,0,0.9)' }}>
                          {a.desc}
                        </p>
                        <span className="inline-flex items-center gap-1 text-xs font-bold px-2.5 py-1"
                          style={{
                            background: 'rgba(200,121,65,0.85)',
                            border: '1px solid rgba(200,121,65,1)',
                            borderRadius: '4px',
                            color: '#fff',
                          }}>
                          <i className="ri-refresh-line text-xs"></i>
                          {a.uses}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Valor total */}
              <div className="mt-12 p-8 text-center"
                style={{
                  background: 'rgba(26,58,110,0.95)',
                  border: '1px solid rgba(200,121,65,0.4)',
                  borderRadius: '4px',
                  backdropFilter: 'blur(12px)',
                }}>
                <p className="text-white/70 text-sm mb-2 uppercase tracking-widest font-semibold">Valor total en beneficios</p>
                <p className="text-5xl font-black text-white mb-1">
                  $<span style={{ color: '#C87941' }}>500.000</span>
                </p>
                <p className="text-white/55 text-xs">COP en asistencias y coberturas</p>
              </div>

              {/* ── AVISO REQUISITO TECNOMECÁNICA ── */}
              <div className="mt-8 p-6 flex items-start gap-4"
                style={{
                  background: 'linear-gradient(135deg, rgba(255,107,26,0.1), rgba(232,160,32,0.08))',
                  border: '1px solid rgba(255,107,26,0.45)',
                  borderRadius: '4px',
                }}>
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center"
                  style={{ background: 'rgba(255,107,26,0.2)', border: '1px solid rgba(255,107,26,0.5)', borderRadius: '4px' }}>
                  <i className="ri-error-warning-line text-lg" style={{ color: '#FF6B1A' }}></i>
                </div>
                <div>
                  <p className="text-white font-black text-sm mb-1">Requisito obligatorio de participación</p>
                  <p className="text-white/70 text-xs leading-relaxed">
                    Estas asistencias aplican <strong className="text-white">exclusivamente</strong> para conductores que hayan cumplido con la{' '}
                    <strong style={{ color: '#FF6B1A' }}>Revisión Técnico-Mecánica y de Gases (RTM-EC)</strong> vigente de su vehículo
                    y que hayan realizado su <strong className="text-white">registro en el formulario del Programa Empresarial Privado</strong>,
                    de acuerdo al canal de contacto asignado por el Taller Aliado u Operador Automotriz registrado en la Alianza de Beneficios. Los beneficios se verifican y activan una vez completado el proceso técnico en el CDA. Sin estos requisitos, el acceso a los beneficios no es válido.
                  </p>
                </div>
              </div>

              {/* ── TÉRMINOS Y CONDICIONES ── */}
              <div className="mt-8"
                style={{
                  background: 'rgba(10,22,40,0.85)',
                  border: '1px solid rgba(32,192,208,0.2)',
                  borderRadius: '4px',
                  backdropFilter: 'blur(14px)',
                }}>
                {/* Header */}
                <div className="px-8 py-5 flex items-center gap-3"
                  style={{ borderBottom: '1px solid rgba(32,192,208,0.15)' }}>
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0"
                    style={{ background: 'rgba(200,121,65,0.15)', border: '1px solid rgba(200,121,65,0.35)', borderRadius: '4px' }}>
                    <i className="ri-file-list-3-line text-lg" style={{ color: '#C87941' }}></i>
                  </div>
                  <div>
                    <h3 className="text-white font-black text-base tracking-wide">Términos y Condiciones — Card Plus</h3>
                    <p className="text-white/40 text-xs">Asistencia Plus Colombia S.A.S. · Responsable del respaldo de la Card Plus</p>
                  </div>
                </div>

                <div className="p-8 grid md:grid-cols-2 gap-8">
                  {/* Cap 1 */}
                  <div>
                    <p className="text-xs font-black uppercase tracking-widest mb-4" style={{ color: '#C87941' }}>
                      Capítulo 1 — Cobertura y Vigencia
                    </p>
                    <ul className="flex flex-col gap-3">
                      {[
                        { icon: 'ri-money-dollar-circle-line', text: 'Límite de hasta $100.000 por cada asistencia.' },
                        { icon: 'ri-map-pin-line', text: 'Aplica únicamente en Colombia, ciudades principales y dentro del perímetro urbano.' },
                        { icon: 'ri-calendar-check-line', text: 'Vigencia de 12 meses con carencia inicial de 24 horas.' },
                        { icon: 'ri-lock-line', text: 'No transferible. Exclusivo para el vehículo y propietario registrado según RUNT.' },
                      ].map((item, i) => (
                        <li key={i} className="flex items-start gap-3">
                          <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center mt-0.5"
                            style={{ background: 'rgba(200,121,65,0.12)', border: '1px solid rgba(200,121,65,0.25)', borderRadius: '3px' }}>
                            <i className={`${item.icon} text-xs`} style={{ color: '#C87941' }}></i>
                          </div>
                          <span className="text-white/65 text-xs leading-relaxed">{item.text}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Cap 2 */}
                  <div>
                    <p className="text-xs font-black uppercase tracking-widest mb-4" style={{ color: '#C87941' }}>
                      Capítulo 2 — Condiciones Generales
                    </p>
                    <ul className="flex flex-col gap-3">
                      {[
                        { icon: 'ri-refresh-line', text: '1 uso/año: Reinicio de batería, Documentos protegidos, Te lo llevamos y Guardería de mascotas.' },
                        { icon: 'ri-loop-right-line', text: '2 usos/año: Traslado al aeropuerto, Orientación veterinaria, Mecánico por video y Orientación médica.' },
                        { icon: 'ri-receipt-line', text: 'Reembolsos requieren factura legal electrónica y soportes documentales completos.' },
                        { icon: 'ri-alarm-warning-line', text: 'Los eventos deben reportarse dentro de las 24 horas siguientes al suceso.' },
                      ].map((item, i) => (
                        <li key={i} className="flex items-start gap-3">
                          <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center mt-0.5"
                            style={{ background: 'rgba(200,121,65,0.12)', border: '1px solid rgba(200,121,65,0.25)', borderRadius: '3px' }}>
                            <i className={`${item.icon} text-xs`} style={{ color: '#C87941' }}></i>
                          </div>
                          <span className="text-white/65 text-xs leading-relaxed">{item.text}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Cap 3 */}
                  <div>
                    <p className="text-xs font-black uppercase tracking-widest mb-4" style={{ color: '#C87941' }}>
                      Capítulo 3 — Condiciones Específicas
                    </p>
                    <ul className="flex flex-col gap-3">
                      {[
                        { icon: 'ri-flight-takeoff-line', text: 'Traslado al aeropuerto: Servicio programado, trayecto directo y horarios establecidos.' },
                        { icon: 'ri-battery-charge-line', text: 'Reinicio de batería: Solo para imprevistos fortuitos en vía pública (fuera del domicilio habitual).' },
                        { icon: 'ri-heart-pulse-line', text: 'Médica/Veterinaria: Servicio 24/7 de medios. No sustituye atención presencial.' },
                        { icon: 'ri-video-chat-line', text: 'Mecánico por video: Diagnóstico remoto. No incluye envío de carro taller.' },
                        { icon: 'ri-e-bike-line', text: 'Te lo llevamos: Máx. 1 kg, 40 cm por cara, trayecto hasta 20 km. Excluye bienes restringidos.' },
                        { icon: 'ri-home-heart-line', text: 'Guardería: Solo para perros y gatos con soportes de viaje del dueño.' },
                      ].map((item, i) => (
                        <li key={i} className="flex items-start gap-3">
                          <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center mt-0.5"
                            style={{ background: 'rgba(200,121,65,0.12)', border: '1px solid rgba(200,121,65,0.25)', borderRadius: '3px' }}>
                            <i className={`${item.icon} text-xs`} style={{ color: '#C87941' }}></i>
                          </div>
                          <span className="text-white/65 text-xs leading-relaxed">{item.text}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Cap 4 + Contacto */}
                  <div className="flex flex-col gap-6">
                    <div>
                      <p className="text-xs font-black uppercase tracking-widest mb-4" style={{ color: '#C87941' }}>
                        Capítulo 4 — Responsabilidad
                      </p>
                      <ul className="flex flex-col gap-3">
                        {[
                          { icon: 'ri-shield-check-line', text: 'Los reembolsos de asistencias no programables requieren aval previo de APC.' },
                          { icon: 'ri-building-2-line', text: 'Asistencia Plus Colombia S.A.S. es el único responsable del respaldo de la Card Plus.' },
                        ].map((item, i) => (
                          <li key={i} className="flex items-start gap-3">
                            <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center mt-0.5"
                              style={{ background: 'rgba(200,121,65,0.12)', border: '1px solid rgba(200,121,65,0.25)', borderRadius: '3px' }}>
                              <i className={`${item.icon} text-xs`} style={{ color: '#C87941' }}></i>
                            </div>
                            <span className="text-white/65 text-xs leading-relaxed">{item.text}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Datos de contacto */}
                    <div className="p-5"
                      style={{
                        background: 'rgba(200,121,65,0.08)',
                        border: '1px solid rgba(200,121,65,0.3)',
                        borderRadius: '4px',
                      }}>
                      <p className="text-xs font-black uppercase tracking-widest mb-4" style={{ color: '#C87941' }}>
                        Líneas de Atención
                      </p>
                      <div className="flex flex-col gap-2.5">
                        {[
                          { icon: 'ri-phone-line', text: '333 033 3575' },
                          { icon: 'ri-phone-line', text: '(601) 489 8313' },
                          { icon: 'ri-phone-line', text: '304 333 7999' },
                          { icon: 'ri-global-line', text: 'tumecanico.club' },
                        ].map((item, i) => (
                          <div key={i} className="flex items-center gap-2.5">
                            <i className={`${item.icon} text-sm flex-shrink-0`} style={{ color: '#C87941' }}></i>
                            <span className="text-white/80 text-sm font-semibold">{item.text}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ── KIT VELKO ── */}
          {activeTab === 'kit' && (
            <div>
              <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-black text-white mb-3">
                  <span style={{ color: '#C87941' }}>KIT DE PREVENCIÓN VELKO</span>
                </h2>
                <p className="text-white/70 text-sm max-w-2xl mx-auto leading-relaxed">
                  Recibe sin costo adicional tu Kit Profesional VELKO. Un beneficio físico de prevención (líquidos y limpieza) para el cuidado de tu vehículo, entregado por la Alianza al finalizar tu revisión. Al completar tu RTM con el Taller Aliado y verificar el proceso técnico en el CDA, activas automáticamente tu Kit adaptado al tipo de vehículo registrado. No es un regalo por entrar — es tu recompensa por cumplir con tu responsabilidad vial.
                </p>
              </div>

              {/* ── NOTA DE ENTREGA ── */}
              <div className="mb-8 p-5 flex items-start gap-4"
                style={{
                  background: 'linear-gradient(135deg, rgba(200,121,65,0.12), rgba(232,160,32,0.08))',
                  border: '1px solid rgba(200,121,65,0.55)',
                  borderRadius: '4px',
                }}>
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center"
                  style={{ background: 'linear-gradient(135deg, #C87941, #E8A020)', borderRadius: '4px', boxShadow: '0 0 16px rgba(200,121,65,0.4)' }}>
                  <i className="ri-gift-line text-white text-lg"></i>
                </div>
                <div>
                  <p className="text-white font-black text-sm mb-1 uppercase tracking-widest">
                    ¿Cuándo recibes tu Kit Profesional VELKO?
                  </p>
                  <p className="text-white/75 text-xs leading-relaxed">
                    El Kit Profesional VELKO se entrega <strong className="text-white">el mismo día que realizas tu Revisión Tecnomecánica (RTM)</strong> con el Taller Aliado, una vez verificado el proceso técnico en el CDA.{' '}
                    <strong style={{ color: '#E8A020' }}>No requiere compra de llantas ni ningún otro requisito adicional</strong> — es tu recompensa directa por cumplir con tu responsabilidad vial.
                  </p>
                </div>
              </div>

              <div className="flex flex-col gap-5">

                {/* ── FILA 1: Todo vehículo ── */}
                <div className="grid md:grid-cols-[380px_1fr] overflow-hidden"
                  style={{ border: '1px solid rgba(200,121,65,0.45)', borderRadius: '4px', background: 'rgba(26,58,110,0.9)', backdropFilter: 'blur(10px)' }}>
                  <div className="relative w-full flex flex-col items-center justify-center gap-3" style={{ minHeight: '220px', background: 'linear-gradient(135deg, rgba(15,32,64,0.97) 0%, rgba(26,58,110,0.92) 100%)' }}>
                    <div className="w-14 h-14 flex items-center justify-center"
                      style={{ background: 'rgba(200,121,65,0.12)', border: '1px solid rgba(200,121,65,0.3)', borderRadius: '4px' }}>
                      <i className="ri-image-add-line text-2xl" style={{ color: 'rgba(200,121,65,0.5)' }}></i>
                    </div>
                    <p className="text-xs font-bold tracking-widest uppercase text-center px-4" style={{ color: 'rgba(200,121,65,0.4)' }}>Imagen próximamente</p>
                    <div className="absolute top-4 left-4">
                      <span className="inline-flex items-center gap-1.5 text-[10px] font-black px-2.5 py-1 uppercase tracking-widest"
                        style={{ background: 'linear-gradient(135deg,#C87941,#E8A020)', borderRadius: '4px', color: '#fff' }}>
                        <i className="ri-car-line"></i> Todo vehículo
                      </span>
                    </div>
                  </div>
                  <div className="p-7 flex flex-col justify-center">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-7 h-7 flex items-center justify-center flex-shrink-0"
                        style={{ background: 'linear-gradient(135deg, #C87941, #E8A020)', borderRadius: '4px' }}>
                        <i className="ri-car-line text-white text-sm"></i>
                      </div>
                      <p className="text-white font-black text-sm uppercase tracking-widest">Para todo vehículo</p>
                    </div>
                    <p className="text-white/60 text-xs mb-5 leading-relaxed">
                      Sin importar el tipo de vehículo registrado, todos los participantes del programa reciben los siguientes tres productos de mantenimiento preventivo:
                    </p>
                    <div className="flex flex-col gap-3">
                      {kitProducts.map((p, i) => (
                        <div key={i} className="flex items-center gap-3">
                          <div className="w-8 h-8 flex items-center justify-center flex-shrink-0"
                            style={{ background: 'rgba(200,121,65,0.18)', border: '1px solid rgba(200,121,65,0.4)', borderRadius: '4px' }}>
                            <i className={`${p.icon} text-sm`} style={{ color: '#E8A020' }}></i>
                          </div>
                          <p className="text-white font-semibold text-sm">{p.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* ── FILA 2: Público de pasajeros ── */}
                <div className="grid md:grid-cols-[380px_1fr] overflow-hidden"
                  style={{ border: '1px solid rgba(200,121,65,0.45)', borderRadius: '4px', background: 'rgba(26,58,110,0.9)', backdropFilter: 'blur(10px)' }}>
                  <div className="relative w-full flex flex-col items-center justify-center gap-3" style={{ minHeight: '200px', background: 'linear-gradient(135deg, rgba(15,32,64,0.97) 0%, rgba(26,58,110,0.92) 100%)' }}>
                    <div className="w-14 h-14 flex items-center justify-center"
                      style={{ background: 'rgba(200,121,65,0.12)', border: '1px solid rgba(200,121,65,0.3)', borderRadius: '4px' }}>
                      <i className="ri-image-add-line text-2xl" style={{ color: 'rgba(200,121,65,0.5)' }}></i>
                    </div>
                    <p className="text-xs font-bold tracking-widest uppercase text-center px-4" style={{ color: 'rgba(200,121,65,0.4)' }}>Imagen próximamente</p>
                    <div className="absolute top-4 left-4">
                      <span className="inline-flex items-center gap-1.5 text-[10px] font-black px-2.5 py-1 uppercase tracking-widest"
                        style={{ background: 'linear-gradient(135deg,#C87941,#E8A020)', borderRadius: '4px', color: '#fff' }}>
                        <i className="ri-bus-line"></i> Público pasajeros
                      </span>
                    </div>
                  </div>
                  <div className="p-7 flex flex-col justify-center">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-7 h-7 flex items-center justify-center flex-shrink-0"
                        style={{ background: 'linear-gradient(135deg, #C87941, #E8A020)', borderRadius: '4px' }}>
                        <i className="ri-bus-line text-white text-sm"></i>
                      </div>
                      <p className="text-white font-black text-sm uppercase tracking-widest">Vehículo liviano público de pasajeros</p>
                    </div>
                    <p className="text-white/60 text-xs mb-5 leading-relaxed">
                      Adicionalmente al kit base, los vehículos livianos de servicio público de pasajeros reciben un beneficio exclusivo de alto valor que cubre todas sus revisiones preventivas:
                    </p>
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center flex-shrink-0"
                        style={{ background: 'rgba(200,121,65,0.18)', border: '1px solid rgba(200,121,65,0.4)', borderRadius: '4px' }}>
                        <i className="ri-shield-star-line text-sm" style={{ color: '#E8A020' }}></i>
                      </div>
                      <div>
                        <p className="text-white/50 text-[10px] font-semibold uppercase tracking-widest">Beneficio exclusivo</p>
                        <p className="text-white font-bold text-sm">Revisiones Preventivas Gratuitas</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ── FILA 3: Motocicleta ── */}
                <div className="grid md:grid-cols-[380px_1fr] overflow-hidden"
                  style={{ border: '1px solid rgba(32,192,208,0.3)', borderRadius: '4px', background: 'rgba(26,58,110,0.9)', backdropFilter: 'blur(10px)' }}>
                  <div className="relative w-full flex flex-col items-center justify-center gap-3" style={{ minHeight: '200px', background: 'linear-gradient(135deg, rgba(15,32,64,0.97) 0%, rgba(26,58,110,0.92) 100%)' }}>
                    <div className="w-14 h-14 flex items-center justify-center"
                      style={{ background: 'rgba(200,121,65,0.12)', border: '1px solid rgba(200,121,65,0.3)', borderRadius: '4px' }}>
                      <i className="ri-image-add-line text-2xl" style={{ color: 'rgba(200,121,65,0.5)' }}></i>
                    </div>
                    <p className="text-xs font-bold tracking-widest uppercase text-center px-4" style={{ color: 'rgba(200,121,65,0.4)' }}>Imagen próximamente</p>
                    <div className="absolute top-4 left-4">
                      <span className="inline-flex items-center gap-1.5 text-[10px] font-black px-2.5 py-1 uppercase tracking-widest"
                        style={{ background: 'linear-gradient(135deg,#C87941,#E8A020)', borderRadius: '4px', color: '#fff' }}>
                        <i className="ri-motorbike-line"></i> Motocicleta
                      </span>
                    </div>
                  </div>
                  <div className="p-7 flex flex-col justify-center">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-7 h-7 flex items-center justify-center flex-shrink-0"
                        style={{ background: 'linear-gradient(135deg, #C87941, #E8A020)', borderRadius: '4px' }}>
                        <i className="ri-motorbike-line text-white text-sm"></i>
                      </div>
                      <p className="text-white font-black text-sm uppercase tracking-widest">Motocicleta</p>
                    </div>

                    {/* Aviso: sin kit base */}
                    <div className="mb-5 px-4 py-3 flex items-start gap-3"
                      style={{
                        background: 'rgba(232,160,32,0.08)',
                        border: '1px solid rgba(232,160,32,0.35)',
                        borderRadius: '4px',
                      }}>
                      <i className="ri-information-line text-sm flex-shrink-0 mt-0.5" style={{ color: '#E8A020' }}></i>
                      <p className="text-white/70 text-xs leading-relaxed">
                        <strong className="text-white">Las motocicletas no incluyen el Kit Base VELKO</strong> (refrigerante, líquido de frenos ni spray multipropósito). Su bonificación por RTM consiste en la <strong style={{ color: '#E8A020' }}>Tarjeta Card Plus</strong> y un producto especializado para el cuidado de la cadena:
                      </p>
                    </div>

                    <div className="flex flex-col gap-3">
                      {/* Card Plus */}
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 flex items-center justify-center flex-shrink-0"
                          style={{ background: 'rgba(200,121,65,0.18)', border: '1px solid rgba(200,121,65,0.4)', borderRadius: '4px' }}>
                          <i className="ri-customer-service-2-line text-sm" style={{ color: '#E8A020' }}></i>
                        </div>
                        <div>
                          <p className="text-white/50 text-[10px] font-semibold uppercase tracking-widest">Asistencias · Al hacer tu RTM</p>
                          <p className="text-white font-bold text-sm">Tarjeta de Asistencia Card Plus</p>
                        </div>
                      </div>
                      {/* Limpiador de cadena */}
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 flex items-center justify-center flex-shrink-0"
                          style={{ background: 'rgba(200,121,65,0.18)', border: '1px solid rgba(200,121,65,0.4)', borderRadius: '4px' }}>
                          <i className="ri-oil-line text-sm" style={{ color: '#E8A020' }}></i>
                        </div>
                        <div>
                          <p className="text-white/50 text-[10px] font-semibold uppercase tracking-widest">Producto especializado · Exclusivo moto</p>
                          <p className="text-white font-bold text-sm">Limpiador de Cadena para Moto</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              {/* CTA Kit Velko */}
              <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                <button onClick={openAgent}
                  className="inline-flex items-center gap-3 font-black px-8 py-4 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap text-sm text-white uppercase tracking-widest"
                  style={{
                    background: 'linear-gradient(135deg, #C87941, #E8A020)',
                    borderRadius: '4px',
                    boxShadow: '0 4px 20px rgba(200,121,65,0.4)',
                  }}
                  onMouseEnter={e => (e.currentTarget.style.boxShadow = '0 0 28px 6px rgba(220,100,20,0.55)')}
                  onMouseLeave={e => (e.currentTarget.style.boxShadow = '0 4px 20px rgba(200,121,65,0.4)')}>
                  <i className="ri-mic-line text-base"></i>
                  Hablar con el Agente
                </button>
                <Link to="/contacto"
                  className="inline-flex items-center gap-3 font-black px-8 py-4 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap text-sm text-white uppercase tracking-widest"
                  style={{
                    background: 'rgba(255,255,255,0.08)',
                    border: '1px solid rgba(200,121,65,0.45)',
                    borderRadius: '4px',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'rgba(200,121,65,0.15)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; }}>
                  <i className="ri-trophy-line text-base"></i>
                  Activar mi Paquete de Beneficios
                </Link>
              </div>
            </div>
          )}
        </div>
      </section>



      {/* ── CTA AGENTE ── */}
      <section className="py-20 relative overflow-hidden" style={{ background: '#1a3a6e' }}>
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20dark%20background%20with%20glowing%20cyan%20teal%20light%20particles%20and%20bokeh%20effects%2C%20futuristic%20technology%20atmosphere%2C%20deep%20dark%20navy%20background%20with%20subtle%20light%20streaks%2C%20premium%20automotive%20brand%20aesthetic%2C%20ultra%20high%20quality%20render&width=1920&height=600&seq=cta-agent-bg&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
            style={{ opacity: 0.22, filter: 'saturate(0.8)' }}
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, #1a3a6e 0%, transparent 40%, #1a3a6e 100%)' }}></div>
        </div>

        <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
          <div className="w-20 h-20 flex items-center justify-center mx-auto mb-8"
            style={{
              background: 'linear-gradient(135deg, #C87941, #E8A020)',
              borderRadius: '4px',
              boxShadow: '0 0 40px rgba(200,121,65,0.45)',
            }}>
            <i className="ri-robot-2-line text-white text-3xl"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">¿Tienes dudas sobre tu paquete?</h2>
          <p className="text-white/75 text-lg mb-8 leading-relaxed">
            Nuestro agente inteligente responde todas tus preguntas sobre la Alianza de Beneficios, el Programa Empresarial Privado, el Reconocimiento Especial y tus bonificaciones en tiempo real, por voz o chat.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button onClick={openAgent}
              className="inline-flex items-center gap-3 font-black px-10 py-4 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap text-lg text-white uppercase tracking-widest"
              style={{
                background: 'linear-gradient(135deg, #C87941, #E8A020)',
                borderRadius: '4px',
                boxShadow: '0 4px 20px rgba(200,121,65,0.4)',
              }}
              onMouseEnter={e => (e.currentTarget.style.boxShadow = '0 0 28px 6px rgba(220,100,20,0.55)')}
              onMouseLeave={e => (e.currentTarget.style.boxShadow = '0 4px 20px rgba(200,121,65,0.4)')}>
              <i className="ri-mic-line text-xl"></i>
              Hablar con el Agente
            </button>
            <Link to="/contacto"
              className="inline-flex items-center gap-3 font-black px-10 py-4 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap text-sm text-white uppercase tracking-widest"
              style={{
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(200,121,65,0.45)',
                borderRadius: '4px',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(200,121,65,0.15)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; }}>
              <i className="ri-trophy-line text-base"></i>
              Activar mi Paquete de Beneficios
            </Link>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer style={{ background: '#0a1e3d', borderTop: '1px solid rgba(200,121,65,0.2)' }}>
        <div style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }} className="py-10">
          <div className="max-w-6xl mx-auto px-6 flex items-center gap-5">
            <img
              src="https://static.readdy.ai/image/257ded5cf4b1165b373a01f4236f0b3a/e052755f997086e5f1ed7f5d0f41046d.png"
              alt="Tu Revisión Segura Logo"
              className="h-14 w-auto object-contain"
              style={{ filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.8))' }}
            />
            <div className="h-10 w-px bg-white/15"></div>
            <div>
              <p className="text-white font-black text-lg tracking-widest">REVISION SEGURA</p>
              <p className="text-white/40 text-xs tracking-widest">VERIFICACIÓN DE OFICIAL · BOGOTÁ, COLOMBIA</p>
            </div>
          </div>
        </div>
        <div className="py-14">
          <div className="max-w-6xl mx-auto px-6 grid sm:grid-cols-2 gap-10">
            <div>
              <h4 className="text-white/70 text-xs font-bold uppercase tracking-widest mb-4">Sobre el Programa</h4>
              <p className="text-white/40 text-xs leading-relaxed mb-5">REVISION SEGURA es el programa oficial de reconocimiento empresarial para conductores responsables en Bogotá, Colombia.</p>
              <div className="flex items-center gap-2 text-white/35 text-xs"><i className="ri-map-pin-line" style={{ color: 'rgba(200,121,65,0.6)' }}></i><span>Bogotá, Colombia</span></div>
              <div className="flex items-center gap-2 text-white/35 text-xs mt-1.5"><i className="ri-building-line" style={{ color: 'rgba(200,121,65,0.6)' }}></i><span>NIT 901401495</span></div>
            </div>
            <div>
              <h4 className="text-white/70 text-xs font-bold uppercase tracking-widest mb-4">Aliados</h4>
              <ul className="flex flex-col gap-2.5">
                {['VELKO', 'CARD PLUS', 'Gestión Automotriz AW2020', 'RTM-EC'].map((name) => (
                  <li key={name} className="flex items-center gap-2 text-white/40 text-sm"><i className="ri-checkbox-blank-circle-fill text-[6px]" style={{ color: 'rgba(200,121,65,0.5)' }}></i>{name}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }} className="py-5">
          <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-white/25 text-xs">&copy; 2025 REVISION SEGURA · Gestión Automotriz AW2020 SAS · Todos los derechos reservados.</p>
            <div className="flex items-center gap-4">
              <button onClick={() => window.open('https://lsddbkicdbwbilyhzcrf.supabase.co/storage/v1/object/public/DOCUMENTS/POLITICA-OFICIAL-PROGRAMA-CAV-O2.pdf', '_blank')}
                className="text-white/25 hover:text-white/50 text-xs transition-colors cursor-pointer whitespace-nowrap">Política Oficial</button>
              <span className="text-white/15">·</span>
              <a href="https://readdy.ai/?origin=logo" rel="nofollow" className="text-white/25 hover:text-white/50 text-xs transition-colors">Website Builder</a>
            </div>
          </div>
          <div className="max-w-6xl mx-auto px-6 mt-3">
            <p className="text-white/12 text-[10px] leading-relaxed text-center">
              Turevisionsegura.com es una plataforma de comunicación de Gestión Automotriz AW2020 SAS. Los beneficios son otorgados por la Alianza de Beneficios (Actividad Promocional) y son ajenos a la tarifa legal recaudada por el Centro de Diagnóstico (CDA). Estos premios y bonos no son descuentos directos en la tarifa de la revisión.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
